export default __webpack_public_path__ + "static/Dot-aa6157a8cf4bd3f23d09bca133116802.svg";